module.exports = __webpack_public_path__ + "static/media/wyszukaj.c7b17298.svg";